export * from "modules/TyreDiscountsDashboard/components/AddUpdateTyreBrandDiscountModal/hooks/useAddTyreBrandDiscountMutation";
export * from "modules/TyreDiscountsDashboard/components/AddUpdateTyreBrandDiscountModal/hooks/useUpdateTyreBrandDiscountMutation";
